import {
  DeepPartial,
  SubmitHandler,
  UseFormReturn,
  ValidationMode,
  useForm,
} from "react-hook-form";

import { AnyObjectSchema } from "yup";
import React from "react";
import { yupResolver } from "@hookform/resolvers/yup";

type FormProps<TFormValues> = {
  onSubmit?: SubmitHandler<TFormValues>;
  schema: AnyObjectSchema;
  defaultValues?: DeepPartial<TFormValues>;
  mode?: keyof ValidationMode;
  children: (methods: UseFormReturn<TFormValues>) => React.ReactNode;
};

export const ReusableForm = <TFormValues extends Record<string, any>>({
  onSubmit,
  schema,
  children,
  defaultValues,
  mode,
}: FormProps<TFormValues>) => {
  const methods = useForm<TFormValues>({
    resolver: yupResolver(schema),
    defaultValues,
    mode,
  });
  return (
    <form onSubmit={methods.handleSubmit(onSubmit)}>{children(methods)}</form>
  );
};
